if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}



// WEBPACK FOOTER //
// ./src/js/polyfills/element/matches.js